export const TITLE_OPTIONS = [
  'Kein Titel',
  'Dr.',
  'Dr. med.',
  'Dr. Dr.',
  'Prof. Dr.',
  'Priv. Doz. Dr.',
  'Dipl.-Med.',
  'Dipl.-Psych.',
  'M.Sc.-Psych.',
];

export const NO_TITLE = 'Kein Titel';

export default { TITLE_OPTIONS, NO_TITLE };
